<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-25 16:56:55
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-07 13:52:11
-->
<template>
  <div class="x-sub-page-container" :class="[isFixBtn ? 'fixed-btn' : '']">
    <el-page-header @back="goBack" :content="content"> </el-page-header>
    <div class="sub-containter" :class="[back ? 'background' : '']">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'XSubPage',
    props: {
      content: {
        type: String,
        default: '详情界面'
      },
      isFixBtn: {
        type: Boolean,
        default: false
      },
      back: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      goBack() {
        this.$emit('goBack', this.content)
      }
    }
  }
</script>

<style lang="scss">
  // @import '../../../common/assets/style/variables';

  .x-sub-page-container {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    &.fixed-btn {
      padding-bottom: 70px;
    }

    .sub-containter {
      display: flex;
      flex: 1;
      flex-direction: column;
      height: calc(100% - 40px);
      border-radius: 8px;

      &.background {
        background-color: #fff;
      }
    }

    .el-page-header {
      line-height: 40px;
      background: #fff;
      border-radius: 4px;
      margin-bottom: 10px;
      .el-page-header__left {
        margin-left: 16px;
      }
    }

    .el-page-header__content {
      font-size: 16px;
      color: rgb(62 65 69);
    }
  }
</style>
